var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps",style:(_vm.$global.dynamicCols(_vm.count))},_vm._l((_vm.count),function(index){return _c('div',{key:index,class:`step ${_vm.getClass(index)}`})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }